/* global Swiper */

itsoftApp.createModule("js-slider-2", ["slidersLibrary"], function() {
    var sliderParent = $(".js-slider-2");
    if (!sliderParent.length) {
        return false;
    }

    var swiper;
    var init = function() {


        swiper = new Swiper(sliderParent.get(0), {
            pagination: ".js-pagination-2",
            autoplay: 7500,
            paginationClickable: true,
            mousewheelControl: false,
            spaceBetween: 30,
            longSwipesRatio: 800,
            autoplayDisableOnInteraction: false,


            paginationBulletRender: function(index, className) {
                return "<span class='slide-1__num " + className +   "'>" + (index + 1)  + "<svg class='svg-icon svg-icon--stroke slide-1__title' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 58.7 58.7' xml:space='preserve'><circle class='path' cx='29.3' cy='29.3' r='28.8'/></svg></span>";
            }
        });
        DEBUG && console.log("[module swiper] slider initialized");
    };

    $(".js-pagination-2").on("click", function(){
        swiper.startAutoplay();
    })

    itsoftApp.modules.slidersLibrary.addEvent(init);
});

